"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootTrendsReducer = void 0;
var TrendsReducer_1 = require("@/pages/common/reducers/TrendsReducer");
exports.rootTrendsReducer = {
    trends: TrendsReducer_1.trendsReducer,
};
